(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["matara-home-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (carousel) => {
      if (carousel.dataset.initialised === 'true') return;
      carousel.dataset.initialised = 'true';
      const slides = [...carousel.querySelectorAll('[data-slide]')];
      const dots = [...carousel.querySelectorAll('[data-dot]')];
      const previous = carousel.querySelector('[data-previous]');
      const next = carousel.querySelector('[data-next]');
      const delay = Number(carousel.dataset.delay) || 6000;
      let active = 0;
      let timer;

      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, position) => {
          const selected = position === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        dots.forEach((dot, position) => {
          const selected = position === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => show(active + 1), delay);
        }
      };

      previous?.addEventListener('click', () => { show(active - 1); start(); });
      next?.addEventListener('click', () => { show(active + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.dot)); start(); }));
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      start();
    };

    document.querySelectorAll('[data-matara-carousel]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-matara-carousel]').forEach(initialise);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matara-home-promo-carousel"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=(root)=>{if(root.dataset.init)return;root.dataset.init='1';const slides=[...root.querySelectorAll('[data-offer-slide]')],dots=[...root.querySelectorAll('[data-dot]')],prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');if(!slides.length)return;let i=0,t;const show=(n)=>{i=(n+slides.length)%slides.length;slides.forEach((s,k)=>{s.classList.toggle('is-active',k===i);s.setAttribute('aria-hidden',k===i?'false':'true')});dots.forEach((d,k)=>{d.classList.toggle('is-active',k===i);d.setAttribute('aria-selected',k===i?'true':'false')})};const stop=()=>clearInterval(t),start=()=>{stop();if(slides.length>1&&!matchMedia('(prefers-reduced-motion: reduce)').matches)t=setInterval(()=>show(i+1),Number(root.dataset.delay)||4000)};prev?.addEventListener('click',()=>{show(i-1);start()});next?.addEventListener('click',()=>{show(i+1);start()});dots.forEach(d=>d.addEventListener('click',()=>{show(Number(d.dataset.dot));start()}));root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);root.addEventListener('focusin',stop);root.addEventListener('focusout',start);start()};document.querySelectorAll('[data-matara-offers]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-matara-offers]').forEach(init))})();

  } catch(e) { console.error(e); }
})();
})();
